/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskReportsIssueViewType from '@jira/spa-apps__servicedesk-reports-issue-view/src/ReportsIssueViewSpa.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskReportsIssueView: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskReportsIssueViewType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-reports-issue-view", jiraSpaEntry: "async-servicedesk-reports-issue-view" */ '@jira/spa-apps__servicedesk-reports-issue-view/src/ReportsIssueViewSpa.tsx'
		),
);
type Props = RouteContext;

/**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */

const AsyncServicedeskReportsIssueView = ({ match }: Props): React.JSX.Element => {
	const issueKey = `/${(match.params && match.params.issueKey) || ''}`;
	const timescaleId = `/${(match.params && match.params.timescaleId) || ''}`;
	return (
		<LazyPage
			Page={LazyServicedeskReportsIssueView}
			pageId={`spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskReportsIssueView;
